import React, {ReactHTMLElement, ReactNode, useContext} from "react"
import Img from "gatsby-image"
import * as css from "./ReportPage.module.scss"
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../../context/GlobalContextProvider"
import ReactMarkdown from "react-markdown"
import IconLink from "../../images/icons/link--red-tilted.svg"
import IconMemo from "../../images/icons/memo--red.svg"
import IconYoutube from "../../images/icons/play--red.svg"

type ReportPageProp = {
  image: any;
  pins: {
    image: any | null;
    video: string | null;
    hlink: string | null;
    label: string | null;
    x: string;
    y: string;
  }[];
  htmlContent: string;
};

const ReportPage: React.FC<ReportPageProp> = (prop) => {
  const dispatch = useContext(GlobalDispatchContext)
  const state = useContext(GlobalStateContext)

  const pinEls: ReactNode[] = []
  const attachmentEls: ReactNode[] = []

  if (prop.pins) {
    prop.pins.forEach((pin, i) => {
      let iconImage = <img src={IconMemo} alt={"More Information"}/>
      if (pin.image) {
        iconImage = <Img fixed={pin.image.childImageSharp.fixed} alt=""/>
      } else if (pin.video) {
        iconImage = <img src={IconYoutube} alt={"More Information"}/>
      } else if (pin.hlink) {
        iconImage = <img src={IconLink} alt={"More Information"}/>
      }

      pinEls.push(
        <button
          key={i}
          style={{
            top: `${Number(pin.y) * 100}%`,
            left: `${Number(pin.x) * 100}%`,
          }}
          data-pinid={i}
          onClick={(event) => {
            const pinID = Number(
              (event.target as HTMLButtonElement).dataset.pinid
            )
            const currentPinData = prop.pins[pinID]
            dispatch({
              type: `PIN_MODAL`,
              pinModalContent: currentPinData,
            })
          }}
        >
          <div className={css.buttonImage}>{iconImage}</div>
        </button>
      )

      attachmentEls.push(
        <div key={i} className={css.attachmentWrap__items}>
          <div className={css.attachment}>

            {pin.image && (

              <Img
                className={css.mediaModal__imageBox}
                fluid={pin.image.childImageSharp.fluid}
                alt={``}
                imgStyle={{objectFit: "contain"}}
              />
            )}

          </div>
        </div>
      )
    })
  }

  return (
    <section className={css.singleSection}>
      {state.viewMode === "HTML" ? (
        <ReactMarkdown className={css.htmlTextBox}>
          {prop.htmlContent}
        </ReactMarkdown>
      ) : (
        <div className={css.singleImageBox}>
          {/* ピン */}
          <div className={css.singleImageBox__pins}>{pinEls}</div>

          {state.viewMode === "HIDE-COMMENT" ? (
            <div
              className={css.redFilter + ` ` + css.isVisible}
              style={{
                transform: `rotate(${Math.floor(Math.random() * 6 - 3)}deg)`,
              }}
            />
          ) : (
            <div className={css.redFilter}/>
          )}

          {/* レポート画像 */}
          <Img fluid={prop.image.childImageSharp.fluid} alt=""/>
        </div>
      )}

      {/* 印刷用 */}
      <div className={css.attachmentWrap}>{attachmentEls}</div>
    </section>
  )
}

export default ReportPage
